import DhipayaTruckCard from "./DhipayaTruckCard";
import DhipayaTruckDetails from "./DhipayaTruckDetails";
import "./dhipaya_truck.css";

/**
 * 🟦 DhipayaTruck 3+ / ประเภท 3 รถใหญ่
 * Mapping: ทิพยประกันภัย (Dhipaya)
 */

export default {
  id: "dhipaya_truck_3p",
  company: "ทิพยประกันภัย (Dhipaya)", // ✅ ตรงกับ COMPANY_INFO
  productLine: "motor",
  categories: ["truck", "trailer"],
  nameTH: "ประเภท 3 รถใหญ่",
  description: "ประกันภัยประเภท 3 สำหรับรถบรรทุก หัวลาก และ หางพ่วง",
  accent: "#004aad", // ✅ โทนตาม accent ใน COMPANY_INFO
  expiresAt: "2025-12-31",
  card: DhipayaTruckCard,
  detail: DhipayaTruckDetails,
  active: true,
};
